import { DEBUGGER } from "@/helper/helper";
import { ShareDataProps } from "@/types/all.types";

const useShareOnMobile = () => {
  const shareData = async ({ initialData }: ShareDataProps) => {
    const initialShareData = {
      title: initialData?.sharingData.title || "",
      text: initialData?.sharingData.text || "",
      url: initialData?.sharingData.url || process.env.NEXT_PUBLIC_PREVIEW_TYPES_URL,
    };

    if (navigator) {
      try {
        await navigator.share(initialShareData);
      } catch (err) {
        DEBUGGER("Error sharing data => ", err);
      }
    }
  };

  return { shareData };
};

export default useShareOnMobile;
